/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedArchiveRouteRouteImport } from './routes/_authenticated/archive/route'
import { Route as AuthenticatedAttendanceRouteRouteImport } from './routes/_authenticated/attendance/route'
import { Route as AuthenticatedPeopleRouteRouteImport } from './routes/_authenticated/people/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedWorkRouteRouteImport } from './routes/_authenticated/work/route'
import { Route as AuthenticatedArchiveIndexRouteImport } from './routes/_authenticated/archive/index'
import { Route as AuthenticatedArchivePeopleRouteImport } from './routes/_authenticated/archive/people'
import { Route as AuthenticatedArchiveProjectsRouteImport } from './routes/_authenticated/archive/projects'
import { Route as AuthenticatedAttendanceIndexRouteImport } from './routes/_authenticated/attendance/index'
import { Route as AuthenticatedAttendanceReviewRouteImport } from './routes/_authenticated/attendance/review'
import { Route as AuthenticatedAttendanceSheetRouteImport } from './routes/_authenticated/attendance/sheet'
import { Route as AuthenticatedAttendanceSheetReviewRouteImport } from './routes/_authenticated/attendance/sheet-review'
import { Route as AuthenticatedAttendanceSummaryRouteImport } from './routes/_authenticated/attendance/summary'
import { Route as AuthenticatedPeopleIndexRouteImport } from './routes/_authenticated/people/index'
import { Route as AuthenticatedPeopleLoadRouteImport } from './routes/_authenticated/people/load'
import { Route as AuthenticatedPeopleReviewRouteImport } from './routes/_authenticated/people/review'
import { Route as AuthenticatedPeopleSheetRouteImport } from './routes/_authenticated/people/sheet'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProjectsCodeRouteImport } from './routes/_authenticated/projects/$code'
import { Route as AuthenticatedProjectsDashboardRouteImport } from './routes/_authenticated/projects/dashboard'
import { Route as AuthenticatedProjectsReviewRouteImport } from './routes/_authenticated/projects/review'
import { Route as AuthenticatedProjectsSheetRouteImport } from './routes/_authenticated/projects/sheet'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsArchivedRouteImport } from './routes/_authenticated/settings/archived'
import { Route as AuthenticatedSettingsArchivedPeopleRouteImport } from './routes/_authenticated/settings/archived-people'
import { Route as AuthenticatedSettingsCalendarRouteImport } from './routes/_authenticated/settings/calendar'
import { Route as AuthenticatedSettingsLinksRouteImport } from './routes/_authenticated/settings/links'
import { Route as AuthenticatedSettingsPermissionsRouteImport } from './routes/_authenticated/settings/permissions'
import { Route as AuthenticatedWorkIndexRouteImport } from './routes/_authenticated/work/index'
import { Route as AuthenticatedWorkTasksRouteImport } from './routes/_authenticated/work/tasks'
import { Route as AuthenticatedArchiveHistoryIndexRouteImport } from './routes/_authenticated/archive/history.index'
import { Route as AuthenticatedArchiveHistoryIdRouteImport } from './routes/_authenticated/archive/history.$id'
import { Route as AuthenticatedAttendanceSyncIndexRouteImport } from './routes/_authenticated/attendance/sync.index'
import { Route as AuthenticatedAttendanceSyncIdRouteImport } from './routes/_authenticated/attendance/sync.$id'
import { Route as AuthenticatedPeopleSyncIndexRouteImport } from './routes/_authenticated/people/sync.index'
import { Route as AuthenticatedPeopleSyncIdRouteImport } from './routes/_authenticated/people/sync.$id'
import { Route as AuthenticatedProjectsSyncIndexRouteImport } from './routes/_authenticated/projects/sync.index'
import { Route as AuthenticatedProjectsSyncIdRouteImport } from './routes/_authenticated/projects/sync.$id'
import { Route as AuthenticatedSettingsHistoryIndexRouteImport } from './routes/_authenticated/settings/history.index'
import { Route as AuthenticatedSettingsHistoryIdRouteImport } from './routes/_authenticated/settings/history.$id'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedArchiveRouteRoute =
  AuthenticatedArchiveRouteRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAttendanceRouteRoute =
  AuthenticatedAttendanceRouteRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPeopleRouteRoute =
  AuthenticatedPeopleRouteRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkRouteRoute = AuthenticatedWorkRouteRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedArchiveIndexRoute =
  AuthenticatedArchiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedArchiveRouteRoute,
  } as any)
const AuthenticatedArchivePeopleRoute =
  AuthenticatedArchivePeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthenticatedArchiveRouteRoute,
  } as any)
const AuthenticatedArchiveProjectsRoute =
  AuthenticatedArchiveProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedArchiveRouteRoute,
  } as any)
const AuthenticatedAttendanceIndexRoute =
  AuthenticatedAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedAttendanceReviewRoute =
  AuthenticatedAttendanceReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedAttendanceSheetRoute =
  AuthenticatedAttendanceSheetRouteImport.update({
    id: '/sheet',
    path: '/sheet',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedAttendanceSheetReviewRoute =
  AuthenticatedAttendanceSheetReviewRouteImport.update({
    id: '/sheet-review',
    path: '/sheet-review',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedAttendanceSummaryRoute =
  AuthenticatedAttendanceSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedPeopleIndexRoute =
  AuthenticatedPeopleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPeopleRouteRoute,
  } as any)
const AuthenticatedPeopleLoadRoute = AuthenticatedPeopleLoadRouteImport.update({
  id: '/load',
  path: '/load',
  getParentRoute: () => AuthenticatedPeopleRouteRoute,
} as any)
const AuthenticatedPeopleReviewRoute =
  AuthenticatedPeopleReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedPeopleRouteRoute,
  } as any)
const AuthenticatedPeopleSheetRoute =
  AuthenticatedPeopleSheetRouteImport.update({
    id: '/sheet',
    path: '/sheet',
    getParentRoute: () => AuthenticatedPeopleRouteRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsCodeRoute =
  AuthenticatedProjectsCodeRouteImport.update({
    id: '/projects/$code',
    path: '/projects/$code',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsDashboardRoute =
  AuthenticatedProjectsDashboardRouteImport.update({
    id: '/projects/dashboard',
    path: '/projects/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsReviewRoute =
  AuthenticatedProjectsReviewRouteImport.update({
    id: '/projects/review',
    path: '/projects/review',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsSheetRoute =
  AuthenticatedProjectsSheetRouteImport.update({
    id: '/projects/sheet',
    path: '/projects/sheet',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsArchivedRoute =
  AuthenticatedSettingsArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsArchivedPeopleRoute =
  AuthenticatedSettingsArchivedPeopleRouteImport.update({
    id: '/archived-people',
    path: '/archived-people',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsCalendarRoute =
  AuthenticatedSettingsCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsLinksRoute =
  AuthenticatedSettingsLinksRouteImport.update({
    id: '/links',
    path: '/links',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPermissionsRoute =
  AuthenticatedSettingsPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedWorkIndexRoute = AuthenticatedWorkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedWorkRouteRoute,
} as any)
const AuthenticatedWorkTasksRoute = AuthenticatedWorkTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedWorkRouteRoute,
} as any)
const AuthenticatedArchiveHistoryIndexRoute =
  AuthenticatedArchiveHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => AuthenticatedArchiveRouteRoute,
  } as any)
const AuthenticatedArchiveHistoryIdRoute =
  AuthenticatedArchiveHistoryIdRouteImport.update({
    id: '/history/$id',
    path: '/history/$id',
    getParentRoute: () => AuthenticatedArchiveRouteRoute,
  } as any)
const AuthenticatedAttendanceSyncIndexRoute =
  AuthenticatedAttendanceSyncIndexRouteImport.update({
    id: '/sync/',
    path: '/sync/',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedAttendanceSyncIdRoute =
  AuthenticatedAttendanceSyncIdRouteImport.update({
    id: '/sync/$id',
    path: '/sync/$id',
    getParentRoute: () => AuthenticatedAttendanceRouteRoute,
  } as any)
const AuthenticatedPeopleSyncIndexRoute =
  AuthenticatedPeopleSyncIndexRouteImport.update({
    id: '/sync/',
    path: '/sync/',
    getParentRoute: () => AuthenticatedPeopleRouteRoute,
  } as any)
const AuthenticatedPeopleSyncIdRoute =
  AuthenticatedPeopleSyncIdRouteImport.update({
    id: '/sync/$id',
    path: '/sync/$id',
    getParentRoute: () => AuthenticatedPeopleRouteRoute,
  } as any)
const AuthenticatedProjectsSyncIndexRoute =
  AuthenticatedProjectsSyncIndexRouteImport.update({
    id: '/projects/sync/',
    path: '/projects/sync/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsSyncIdRoute =
  AuthenticatedProjectsSyncIdRouteImport.update({
    id: '/projects/sync/$id',
    path: '/projects/sync/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsHistoryIndexRoute =
  AuthenticatedSettingsHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsHistoryIdRoute =
  AuthenticatedSettingsHistoryIdRouteImport.update({
    id: '/history/$id',
    path: '/history/$id',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/archive': typeof AuthenticatedArchiveRouteRouteWithChildren
  '/attendance': typeof AuthenticatedAttendanceRouteRouteWithChildren
  '/people': typeof AuthenticatedPeopleRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/work': typeof AuthenticatedWorkRouteRouteWithChildren
  '/archive/people': typeof AuthenticatedArchivePeopleRoute
  '/archive/projects': typeof AuthenticatedArchiveProjectsRoute
  '/attendance/review': typeof AuthenticatedAttendanceReviewRoute
  '/attendance/sheet': typeof AuthenticatedAttendanceSheetRoute
  '/attendance/sheet-review': typeof AuthenticatedAttendanceSheetReviewRoute
  '/attendance/summary': typeof AuthenticatedAttendanceSummaryRoute
  '/people/load': typeof AuthenticatedPeopleLoadRoute
  '/people/review': typeof AuthenticatedPeopleReviewRoute
  '/people/sheet': typeof AuthenticatedPeopleSheetRoute
  '/projects/$code': typeof AuthenticatedProjectsCodeRoute
  '/projects/dashboard': typeof AuthenticatedProjectsDashboardRoute
  '/projects/review': typeof AuthenticatedProjectsReviewRoute
  '/projects/sheet': typeof AuthenticatedProjectsSheetRoute
  '/settings/archived': typeof AuthenticatedSettingsArchivedRoute
  '/settings/archived-people': typeof AuthenticatedSettingsArchivedPeopleRoute
  '/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/settings/links': typeof AuthenticatedSettingsLinksRoute
  '/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/work/tasks': typeof AuthenticatedWorkTasksRoute
  '/archive/': typeof AuthenticatedArchiveIndexRoute
  '/attendance/': typeof AuthenticatedAttendanceIndexRoute
  '/people/': typeof AuthenticatedPeopleIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/work/': typeof AuthenticatedWorkIndexRoute
  '/archive/history/$id': typeof AuthenticatedArchiveHistoryIdRoute
  '/attendance/sync/$id': typeof AuthenticatedAttendanceSyncIdRoute
  '/people/sync/$id': typeof AuthenticatedPeopleSyncIdRoute
  '/projects/sync/$id': typeof AuthenticatedProjectsSyncIdRoute
  '/settings/history/$id': typeof AuthenticatedSettingsHistoryIdRoute
  '/archive/history/': typeof AuthenticatedArchiveHistoryIndexRoute
  '/attendance/sync/': typeof AuthenticatedAttendanceSyncIndexRoute
  '/people/sync/': typeof AuthenticatedPeopleSyncIndexRoute
  '/projects/sync/': typeof AuthenticatedProjectsSyncIndexRoute
  '/settings/history/': typeof AuthenticatedSettingsHistoryIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/': typeof AuthenticatedIndexRoute
  '/archive/people': typeof AuthenticatedArchivePeopleRoute
  '/archive/projects': typeof AuthenticatedArchiveProjectsRoute
  '/attendance/review': typeof AuthenticatedAttendanceReviewRoute
  '/attendance/sheet': typeof AuthenticatedAttendanceSheetRoute
  '/attendance/sheet-review': typeof AuthenticatedAttendanceSheetReviewRoute
  '/attendance/summary': typeof AuthenticatedAttendanceSummaryRoute
  '/people/load': typeof AuthenticatedPeopleLoadRoute
  '/people/review': typeof AuthenticatedPeopleReviewRoute
  '/people/sheet': typeof AuthenticatedPeopleSheetRoute
  '/projects/$code': typeof AuthenticatedProjectsCodeRoute
  '/projects/dashboard': typeof AuthenticatedProjectsDashboardRoute
  '/projects/review': typeof AuthenticatedProjectsReviewRoute
  '/projects/sheet': typeof AuthenticatedProjectsSheetRoute
  '/settings/archived': typeof AuthenticatedSettingsArchivedRoute
  '/settings/archived-people': typeof AuthenticatedSettingsArchivedPeopleRoute
  '/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/settings/links': typeof AuthenticatedSettingsLinksRoute
  '/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/work/tasks': typeof AuthenticatedWorkTasksRoute
  '/archive': typeof AuthenticatedArchiveIndexRoute
  '/attendance': typeof AuthenticatedAttendanceIndexRoute
  '/people': typeof AuthenticatedPeopleIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/work': typeof AuthenticatedWorkIndexRoute
  '/archive/history/$id': typeof AuthenticatedArchiveHistoryIdRoute
  '/attendance/sync/$id': typeof AuthenticatedAttendanceSyncIdRoute
  '/people/sync/$id': typeof AuthenticatedPeopleSyncIdRoute
  '/projects/sync/$id': typeof AuthenticatedProjectsSyncIdRoute
  '/settings/history/$id': typeof AuthenticatedSettingsHistoryIdRoute
  '/archive/history': typeof AuthenticatedArchiveHistoryIndexRoute
  '/attendance/sync': typeof AuthenticatedAttendanceSyncIndexRoute
  '/people/sync': typeof AuthenticatedPeopleSyncIndexRoute
  '/projects/sync': typeof AuthenticatedProjectsSyncIndexRoute
  '/settings/history': typeof AuthenticatedSettingsHistoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/archive': typeof AuthenticatedArchiveRouteRouteWithChildren
  '/_authenticated/attendance': typeof AuthenticatedAttendanceRouteRouteWithChildren
  '/_authenticated/people': typeof AuthenticatedPeopleRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/work': typeof AuthenticatedWorkRouteRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/archive/people': typeof AuthenticatedArchivePeopleRoute
  '/_authenticated/archive/projects': typeof AuthenticatedArchiveProjectsRoute
  '/_authenticated/attendance/review': typeof AuthenticatedAttendanceReviewRoute
  '/_authenticated/attendance/sheet': typeof AuthenticatedAttendanceSheetRoute
  '/_authenticated/attendance/sheet-review': typeof AuthenticatedAttendanceSheetReviewRoute
  '/_authenticated/attendance/summary': typeof AuthenticatedAttendanceSummaryRoute
  '/_authenticated/people/load': typeof AuthenticatedPeopleLoadRoute
  '/_authenticated/people/review': typeof AuthenticatedPeopleReviewRoute
  '/_authenticated/people/sheet': typeof AuthenticatedPeopleSheetRoute
  '/_authenticated/projects/$code': typeof AuthenticatedProjectsCodeRoute
  '/_authenticated/projects/dashboard': typeof AuthenticatedProjectsDashboardRoute
  '/_authenticated/projects/review': typeof AuthenticatedProjectsReviewRoute
  '/_authenticated/projects/sheet': typeof AuthenticatedProjectsSheetRoute
  '/_authenticated/settings/archived': typeof AuthenticatedSettingsArchivedRoute
  '/_authenticated/settings/archived-people': typeof AuthenticatedSettingsArchivedPeopleRoute
  '/_authenticated/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/_authenticated/settings/links': typeof AuthenticatedSettingsLinksRoute
  '/_authenticated/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/_authenticated/work/tasks': typeof AuthenticatedWorkTasksRoute
  '/_authenticated/archive/': typeof AuthenticatedArchiveIndexRoute
  '/_authenticated/attendance/': typeof AuthenticatedAttendanceIndexRoute
  '/_authenticated/people/': typeof AuthenticatedPeopleIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/work/': typeof AuthenticatedWorkIndexRoute
  '/_authenticated/archive/history/$id': typeof AuthenticatedArchiveHistoryIdRoute
  '/_authenticated/attendance/sync/$id': typeof AuthenticatedAttendanceSyncIdRoute
  '/_authenticated/people/sync/$id': typeof AuthenticatedPeopleSyncIdRoute
  '/_authenticated/projects/sync/$id': typeof AuthenticatedProjectsSyncIdRoute
  '/_authenticated/settings/history/$id': typeof AuthenticatedSettingsHistoryIdRoute
  '/_authenticated/archive/history/': typeof AuthenticatedArchiveHistoryIndexRoute
  '/_authenticated/attendance/sync/': typeof AuthenticatedAttendanceSyncIndexRoute
  '/_authenticated/people/sync/': typeof AuthenticatedPeopleSyncIndexRoute
  '/_authenticated/projects/sync/': typeof AuthenticatedProjectsSyncIndexRoute
  '/_authenticated/settings/history/': typeof AuthenticatedSettingsHistoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/archive'
    | '/attendance'
    | '/people'
    | '/settings'
    | '/work'
    | '/archive/people'
    | '/archive/projects'
    | '/attendance/review'
    | '/attendance/sheet'
    | '/attendance/sheet-review'
    | '/attendance/summary'
    | '/people/load'
    | '/people/review'
    | '/people/sheet'
    | '/projects/$code'
    | '/projects/dashboard'
    | '/projects/review'
    | '/projects/sheet'
    | '/settings/archived'
    | '/settings/archived-people'
    | '/settings/calendar'
    | '/settings/links'
    | '/settings/permissions'
    | '/work/tasks'
    | '/archive/'
    | '/attendance/'
    | '/people/'
    | '/projects/'
    | '/settings/'
    | '/work/'
    | '/archive/history/$id'
    | '/attendance/sync/$id'
    | '/people/sync/$id'
    | '/projects/sync/$id'
    | '/settings/history/$id'
    | '/archive/history/'
    | '/attendance/sync/'
    | '/people/sync/'
    | '/projects/sync/'
    | '/settings/history/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/'
    | '/archive/people'
    | '/archive/projects'
    | '/attendance/review'
    | '/attendance/sheet'
    | '/attendance/sheet-review'
    | '/attendance/summary'
    | '/people/load'
    | '/people/review'
    | '/people/sheet'
    | '/projects/$code'
    | '/projects/dashboard'
    | '/projects/review'
    | '/projects/sheet'
    | '/settings/archived'
    | '/settings/archived-people'
    | '/settings/calendar'
    | '/settings/links'
    | '/settings/permissions'
    | '/work/tasks'
    | '/archive'
    | '/attendance'
    | '/people'
    | '/projects'
    | '/settings'
    | '/work'
    | '/archive/history/$id'
    | '/attendance/sync/$id'
    | '/people/sync/$id'
    | '/projects/sync/$id'
    | '/settings/history/$id'
    | '/archive/history'
    | '/attendance/sync'
    | '/people/sync'
    | '/projects/sync'
    | '/settings/history'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/archive'
    | '/_authenticated/attendance'
    | '/_authenticated/people'
    | '/_authenticated/settings'
    | '/_authenticated/work'
    | '/_authenticated/'
    | '/_authenticated/archive/people'
    | '/_authenticated/archive/projects'
    | '/_authenticated/attendance/review'
    | '/_authenticated/attendance/sheet'
    | '/_authenticated/attendance/sheet-review'
    | '/_authenticated/attendance/summary'
    | '/_authenticated/people/load'
    | '/_authenticated/people/review'
    | '/_authenticated/people/sheet'
    | '/_authenticated/projects/$code'
    | '/_authenticated/projects/dashboard'
    | '/_authenticated/projects/review'
    | '/_authenticated/projects/sheet'
    | '/_authenticated/settings/archived'
    | '/_authenticated/settings/archived-people'
    | '/_authenticated/settings/calendar'
    | '/_authenticated/settings/links'
    | '/_authenticated/settings/permissions'
    | '/_authenticated/work/tasks'
    | '/_authenticated/archive/'
    | '/_authenticated/attendance/'
    | '/_authenticated/people/'
    | '/_authenticated/projects/'
    | '/_authenticated/settings/'
    | '/_authenticated/work/'
    | '/_authenticated/archive/history/$id'
    | '/_authenticated/attendance/sync/$id'
    | '/_authenticated/people/sync/$id'
    | '/_authenticated/projects/sync/$id'
    | '/_authenticated/settings/history/$id'
    | '/_authenticated/archive/history/'
    | '/_authenticated/attendance/sync/'
    | '/_authenticated/people/sync/'
    | '/_authenticated/projects/sync/'
    | '/_authenticated/settings/history/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/archive': {
      id: '/_authenticated/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof AuthenticatedArchiveRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/attendance': {
      id: '/_authenticated/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AuthenticatedAttendanceRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/people': {
      id: '/_authenticated/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AuthenticatedPeopleRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/work': {
      id: '/_authenticated/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof AuthenticatedWorkRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/archive/': {
      id: '/_authenticated/archive/'
      path: '/'
      fullPath: '/archive/'
      preLoaderRoute: typeof AuthenticatedArchiveIndexRouteImport
      parentRoute: typeof AuthenticatedArchiveRouteRoute
    }
    '/_authenticated/archive/people': {
      id: '/_authenticated/archive/people'
      path: '/people'
      fullPath: '/archive/people'
      preLoaderRoute: typeof AuthenticatedArchivePeopleRouteImport
      parentRoute: typeof AuthenticatedArchiveRouteRoute
    }
    '/_authenticated/archive/projects': {
      id: '/_authenticated/archive/projects'
      path: '/projects'
      fullPath: '/archive/projects'
      preLoaderRoute: typeof AuthenticatedArchiveProjectsRouteImport
      parentRoute: typeof AuthenticatedArchiveRouteRoute
    }
    '/_authenticated/attendance/': {
      id: '/_authenticated/attendance/'
      path: '/'
      fullPath: '/attendance/'
      preLoaderRoute: typeof AuthenticatedAttendanceIndexRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/attendance/review': {
      id: '/_authenticated/attendance/review'
      path: '/review'
      fullPath: '/attendance/review'
      preLoaderRoute: typeof AuthenticatedAttendanceReviewRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/attendance/sheet': {
      id: '/_authenticated/attendance/sheet'
      path: '/sheet'
      fullPath: '/attendance/sheet'
      preLoaderRoute: typeof AuthenticatedAttendanceSheetRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/attendance/sheet-review': {
      id: '/_authenticated/attendance/sheet-review'
      path: '/sheet-review'
      fullPath: '/attendance/sheet-review'
      preLoaderRoute: typeof AuthenticatedAttendanceSheetReviewRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/attendance/summary': {
      id: '/_authenticated/attendance/summary'
      path: '/summary'
      fullPath: '/attendance/summary'
      preLoaderRoute: typeof AuthenticatedAttendanceSummaryRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/people/': {
      id: '/_authenticated/people/'
      path: '/'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthenticatedPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/people/load': {
      id: '/_authenticated/people/load'
      path: '/load'
      fullPath: '/people/load'
      preLoaderRoute: typeof AuthenticatedPeopleLoadRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/people/review': {
      id: '/_authenticated/people/review'
      path: '/review'
      fullPath: '/people/review'
      preLoaderRoute: typeof AuthenticatedPeopleReviewRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/people/sheet': {
      id: '/_authenticated/people/sheet'
      path: '/sheet'
      fullPath: '/people/sheet'
      preLoaderRoute: typeof AuthenticatedPeopleSheetRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$code': {
      id: '/_authenticated/projects/$code'
      path: '/projects/$code'
      fullPath: '/projects/$code'
      preLoaderRoute: typeof AuthenticatedProjectsCodeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/dashboard': {
      id: '/_authenticated/projects/dashboard'
      path: '/projects/dashboard'
      fullPath: '/projects/dashboard'
      preLoaderRoute: typeof AuthenticatedProjectsDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/review': {
      id: '/_authenticated/projects/review'
      path: '/projects/review'
      fullPath: '/projects/review'
      preLoaderRoute: typeof AuthenticatedProjectsReviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/sheet': {
      id: '/_authenticated/projects/sheet'
      path: '/projects/sheet'
      fullPath: '/projects/sheet'
      preLoaderRoute: typeof AuthenticatedProjectsSheetRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/archived': {
      id: '/_authenticated/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof AuthenticatedSettingsArchivedRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/archived-people': {
      id: '/_authenticated/settings/archived-people'
      path: '/archived-people'
      fullPath: '/settings/archived-people'
      preLoaderRoute: typeof AuthenticatedSettingsArchivedPeopleRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/calendar': {
      id: '/_authenticated/settings/calendar'
      path: '/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof AuthenticatedSettingsCalendarRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/links': {
      id: '/_authenticated/settings/links'
      path: '/links'
      fullPath: '/settings/links'
      preLoaderRoute: typeof AuthenticatedSettingsLinksRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/permissions': {
      id: '/_authenticated/settings/permissions'
      path: '/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof AuthenticatedSettingsPermissionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/work/': {
      id: '/_authenticated/work/'
      path: '/'
      fullPath: '/work/'
      preLoaderRoute: typeof AuthenticatedWorkIndexRouteImport
      parentRoute: typeof AuthenticatedWorkRouteRoute
    }
    '/_authenticated/work/tasks': {
      id: '/_authenticated/work/tasks'
      path: '/tasks'
      fullPath: '/work/tasks'
      preLoaderRoute: typeof AuthenticatedWorkTasksRouteImport
      parentRoute: typeof AuthenticatedWorkRouteRoute
    }
    '/_authenticated/archive/history/': {
      id: '/_authenticated/archive/history/'
      path: '/history'
      fullPath: '/archive/history/'
      preLoaderRoute: typeof AuthenticatedArchiveHistoryIndexRouteImport
      parentRoute: typeof AuthenticatedArchiveRouteRoute
    }
    '/_authenticated/archive/history/$id': {
      id: '/_authenticated/archive/history/$id'
      path: '/history/$id'
      fullPath: '/archive/history/$id'
      preLoaderRoute: typeof AuthenticatedArchiveHistoryIdRouteImport
      parentRoute: typeof AuthenticatedArchiveRouteRoute
    }
    '/_authenticated/attendance/sync/': {
      id: '/_authenticated/attendance/sync/'
      path: '/sync'
      fullPath: '/attendance/sync/'
      preLoaderRoute: typeof AuthenticatedAttendanceSyncIndexRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/attendance/sync/$id': {
      id: '/_authenticated/attendance/sync/$id'
      path: '/sync/$id'
      fullPath: '/attendance/sync/$id'
      preLoaderRoute: typeof AuthenticatedAttendanceSyncIdRouteImport
      parentRoute: typeof AuthenticatedAttendanceRouteRoute
    }
    '/_authenticated/people/sync/': {
      id: '/_authenticated/people/sync/'
      path: '/sync'
      fullPath: '/people/sync/'
      preLoaderRoute: typeof AuthenticatedPeopleSyncIndexRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/people/sync/$id': {
      id: '/_authenticated/people/sync/$id'
      path: '/sync/$id'
      fullPath: '/people/sync/$id'
      preLoaderRoute: typeof AuthenticatedPeopleSyncIdRouteImport
      parentRoute: typeof AuthenticatedPeopleRouteRoute
    }
    '/_authenticated/projects/sync/': {
      id: '/_authenticated/projects/sync/'
      path: '/projects/sync'
      fullPath: '/projects/sync/'
      preLoaderRoute: typeof AuthenticatedProjectsSyncIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/sync/$id': {
      id: '/_authenticated/projects/sync/$id'
      path: '/projects/sync/$id'
      fullPath: '/projects/sync/$id'
      preLoaderRoute: typeof AuthenticatedProjectsSyncIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/history/': {
      id: '/_authenticated/settings/history/'
      path: '/history'
      fullPath: '/settings/history/'
      preLoaderRoute: typeof AuthenticatedSettingsHistoryIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/history/$id': {
      id: '/_authenticated/settings/history/$id'
      path: '/history/$id'
      fullPath: '/settings/history/$id'
      preLoaderRoute: typeof AuthenticatedSettingsHistoryIdRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
  }
}

interface AuthenticatedArchiveRouteRouteChildren {
  AuthenticatedArchivePeopleRoute: typeof AuthenticatedArchivePeopleRoute
  AuthenticatedArchiveProjectsRoute: typeof AuthenticatedArchiveProjectsRoute
  AuthenticatedArchiveIndexRoute: typeof AuthenticatedArchiveIndexRoute
  AuthenticatedArchiveHistoryIdRoute: typeof AuthenticatedArchiveHistoryIdRoute
  AuthenticatedArchiveHistoryIndexRoute: typeof AuthenticatedArchiveHistoryIndexRoute
}

const AuthenticatedArchiveRouteRouteChildren: AuthenticatedArchiveRouteRouteChildren =
  {
    AuthenticatedArchivePeopleRoute: AuthenticatedArchivePeopleRoute,
    AuthenticatedArchiveProjectsRoute: AuthenticatedArchiveProjectsRoute,
    AuthenticatedArchiveIndexRoute: AuthenticatedArchiveIndexRoute,
    AuthenticatedArchiveHistoryIdRoute: AuthenticatedArchiveHistoryIdRoute,
    AuthenticatedArchiveHistoryIndexRoute:
      AuthenticatedArchiveHistoryIndexRoute,
  }

const AuthenticatedArchiveRouteRouteWithChildren =
  AuthenticatedArchiveRouteRoute._addFileChildren(
    AuthenticatedArchiveRouteRouteChildren,
  )

interface AuthenticatedAttendanceRouteRouteChildren {
  AuthenticatedAttendanceReviewRoute: typeof AuthenticatedAttendanceReviewRoute
  AuthenticatedAttendanceSheetRoute: typeof AuthenticatedAttendanceSheetRoute
  AuthenticatedAttendanceSheetReviewRoute: typeof AuthenticatedAttendanceSheetReviewRoute
  AuthenticatedAttendanceSummaryRoute: typeof AuthenticatedAttendanceSummaryRoute
  AuthenticatedAttendanceIndexRoute: typeof AuthenticatedAttendanceIndexRoute
  AuthenticatedAttendanceSyncIdRoute: typeof AuthenticatedAttendanceSyncIdRoute
  AuthenticatedAttendanceSyncIndexRoute: typeof AuthenticatedAttendanceSyncIndexRoute
}

const AuthenticatedAttendanceRouteRouteChildren: AuthenticatedAttendanceRouteRouteChildren =
  {
    AuthenticatedAttendanceReviewRoute: AuthenticatedAttendanceReviewRoute,
    AuthenticatedAttendanceSheetRoute: AuthenticatedAttendanceSheetRoute,
    AuthenticatedAttendanceSheetReviewRoute:
      AuthenticatedAttendanceSheetReviewRoute,
    AuthenticatedAttendanceSummaryRoute: AuthenticatedAttendanceSummaryRoute,
    AuthenticatedAttendanceIndexRoute: AuthenticatedAttendanceIndexRoute,
    AuthenticatedAttendanceSyncIdRoute: AuthenticatedAttendanceSyncIdRoute,
    AuthenticatedAttendanceSyncIndexRoute:
      AuthenticatedAttendanceSyncIndexRoute,
  }

const AuthenticatedAttendanceRouteRouteWithChildren =
  AuthenticatedAttendanceRouteRoute._addFileChildren(
    AuthenticatedAttendanceRouteRouteChildren,
  )

interface AuthenticatedPeopleRouteRouteChildren {
  AuthenticatedPeopleLoadRoute: typeof AuthenticatedPeopleLoadRoute
  AuthenticatedPeopleReviewRoute: typeof AuthenticatedPeopleReviewRoute
  AuthenticatedPeopleSheetRoute: typeof AuthenticatedPeopleSheetRoute
  AuthenticatedPeopleIndexRoute: typeof AuthenticatedPeopleIndexRoute
  AuthenticatedPeopleSyncIdRoute: typeof AuthenticatedPeopleSyncIdRoute
  AuthenticatedPeopleSyncIndexRoute: typeof AuthenticatedPeopleSyncIndexRoute
}

const AuthenticatedPeopleRouteRouteChildren: AuthenticatedPeopleRouteRouteChildren =
  {
    AuthenticatedPeopleLoadRoute: AuthenticatedPeopleLoadRoute,
    AuthenticatedPeopleReviewRoute: AuthenticatedPeopleReviewRoute,
    AuthenticatedPeopleSheetRoute: AuthenticatedPeopleSheetRoute,
    AuthenticatedPeopleIndexRoute: AuthenticatedPeopleIndexRoute,
    AuthenticatedPeopleSyncIdRoute: AuthenticatedPeopleSyncIdRoute,
    AuthenticatedPeopleSyncIndexRoute: AuthenticatedPeopleSyncIndexRoute,
  }

const AuthenticatedPeopleRouteRouteWithChildren =
  AuthenticatedPeopleRouteRoute._addFileChildren(
    AuthenticatedPeopleRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsArchivedRoute: typeof AuthenticatedSettingsArchivedRoute
  AuthenticatedSettingsArchivedPeopleRoute: typeof AuthenticatedSettingsArchivedPeopleRoute
  AuthenticatedSettingsCalendarRoute: typeof AuthenticatedSettingsCalendarRoute
  AuthenticatedSettingsLinksRoute: typeof AuthenticatedSettingsLinksRoute
  AuthenticatedSettingsPermissionsRoute: typeof AuthenticatedSettingsPermissionsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsHistoryIdRoute: typeof AuthenticatedSettingsHistoryIdRoute
  AuthenticatedSettingsHistoryIndexRoute: typeof AuthenticatedSettingsHistoryIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsArchivedRoute: AuthenticatedSettingsArchivedRoute,
    AuthenticatedSettingsArchivedPeopleRoute:
      AuthenticatedSettingsArchivedPeopleRoute,
    AuthenticatedSettingsCalendarRoute: AuthenticatedSettingsCalendarRoute,
    AuthenticatedSettingsLinksRoute: AuthenticatedSettingsLinksRoute,
    AuthenticatedSettingsPermissionsRoute:
      AuthenticatedSettingsPermissionsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsHistoryIdRoute: AuthenticatedSettingsHistoryIdRoute,
    AuthenticatedSettingsHistoryIndexRoute:
      AuthenticatedSettingsHistoryIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedWorkRouteRouteChildren {
  AuthenticatedWorkTasksRoute: typeof AuthenticatedWorkTasksRoute
  AuthenticatedWorkIndexRoute: typeof AuthenticatedWorkIndexRoute
}

const AuthenticatedWorkRouteRouteChildren: AuthenticatedWorkRouteRouteChildren =
  {
    AuthenticatedWorkTasksRoute: AuthenticatedWorkTasksRoute,
    AuthenticatedWorkIndexRoute: AuthenticatedWorkIndexRoute,
  }

const AuthenticatedWorkRouteRouteWithChildren =
  AuthenticatedWorkRouteRoute._addFileChildren(
    AuthenticatedWorkRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedArchiveRouteRoute: typeof AuthenticatedArchiveRouteRouteWithChildren
  AuthenticatedAttendanceRouteRoute: typeof AuthenticatedAttendanceRouteRouteWithChildren
  AuthenticatedPeopleRouteRoute: typeof AuthenticatedPeopleRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedWorkRouteRoute: typeof AuthenticatedWorkRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedProjectsCodeRoute: typeof AuthenticatedProjectsCodeRoute
  AuthenticatedProjectsDashboardRoute: typeof AuthenticatedProjectsDashboardRoute
  AuthenticatedProjectsReviewRoute: typeof AuthenticatedProjectsReviewRoute
  AuthenticatedProjectsSheetRoute: typeof AuthenticatedProjectsSheetRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsSyncIdRoute: typeof AuthenticatedProjectsSyncIdRoute
  AuthenticatedProjectsSyncIndexRoute: typeof AuthenticatedProjectsSyncIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedArchiveRouteRoute: AuthenticatedArchiveRouteRouteWithChildren,
  AuthenticatedAttendanceRouteRoute:
    AuthenticatedAttendanceRouteRouteWithChildren,
  AuthenticatedPeopleRouteRoute: AuthenticatedPeopleRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedWorkRouteRoute: AuthenticatedWorkRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedProjectsCodeRoute: AuthenticatedProjectsCodeRoute,
  AuthenticatedProjectsDashboardRoute: AuthenticatedProjectsDashboardRoute,
  AuthenticatedProjectsReviewRoute: AuthenticatedProjectsReviewRoute,
  AuthenticatedProjectsSheetRoute: AuthenticatedProjectsSheetRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedProjectsSyncIdRoute: AuthenticatedProjectsSyncIdRoute,
  AuthenticatedProjectsSyncIndexRoute: AuthenticatedProjectsSyncIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
